const REVIEW_HOUSE_ID = "HOUSE-02";

const root = document.querySelector("#review-room");

if (root) {
  const assetUrls = {
    rope:
      root.dataset.ropeUrl ||
      "/assets/review-room/letter-rope-grommet-ui-v01.png",
    envelope:
      root.dataset.envelopeUrl || "/assets/icons/phosphor/envelope-simple.svg",
    arrowRight:
      root.dataset.arrowRightUrl || "/assets/icons/phosphor/arrow-right.svg",
  };
  const trigger = root.querySelector("#review-room-trigger");
  const triggerCount = root.querySelector("#review-room-trigger-count");
  const listViewport = root.querySelector("#review-room-list-viewport");
  const list = root.querySelector("#review-room-list");
  const streamStatus = root.querySelector("#review-room-stream-status");
  const backdrop = root.querySelector("#review-room-backdrop");
  const dialog = root.querySelector("#review-room-dialog");
  const closeButton = root.querySelector("#review-room-close");
  const previousButton = root.querySelector("#review-room-previous");
  const nextButton = root.querySelector("#review-room-next");
  const imageButton = root.querySelector("#review-room-photo");
  const image = root.querySelector("#review-room-image");
  const imagePlaceholder = root.querySelector(
    "#review-room-image-placeholder",
  );
  const imageCount = root.querySelector("#review-room-image-count");
  const stars = root.querySelector("#review-room-stars");
  const nickname = root.querySelector("#review-room-nickname");
  const verified = root.querySelector("#review-room-verified");
  const incentivized = root.querySelector("#review-room-incentivized");
  const reviewCopy = root.querySelector("#review-room-copy");
  const product = root.querySelector("#review-room-product");
  const date = root.querySelector("#review-room-date");
  const position = root.querySelector("#review-room-position");
  const status = root.querySelector("#review-room-status");
  const writeReview = root.querySelector("#review-room-write-review");

  const state = {
    reviews: [],
    index: 0,
    photoIndex: 0,
    open: false,
    loading: null,
    pointerStartX: null,
    selected: false,
    inRoom: false,
    lastFocus: null,
    collapsed: false,
    imageWarmup: null,
  };

  function hasSelectedHouse() {
    return Boolean(
      document.querySelector(`[data-id="${REVIEW_HOUSE_ID}"].is-selected`),
    );
  }

  function prepareReviewChrome() {
    root.querySelectorAll("img[data-background-src]").forEach((image) => {
      const source = image.dataset.backgroundSrc;
      if (!source) return;
      image.decoding = "async";
      image.src = source;
      delete image.dataset.backgroundSrc;
    });
  }

  function selectedReview() {
    return state.reviews[state.index] || null;
  }

  function displayNickname(value) {
    const name = String(value || "")
      .trim()
      .replace(/\s+\.+$/, "")
      .replace(/\s{2,}/g, " ");
    if (!name) return "Yizcho collector";
    if (
      /^(?:(?:tik\s*tok|tiktok|etsy|amazon|shopify)(?:\s+shop)?\s+)?(?:customer|buyer|shopper|anonymous)$/i.test(
        name,
      )
    ) {
      return "Yizcho collector";
    }
    return name.slice(0, 40);
  }

  function formatDate(value) {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.valueOf())) return "";
    return new Intl.DateTimeFormat("en", {
      month: "short",
      year: "numeric",
    }).format(parsed);
  }

  function renderReviewList() {
    const fragment = document.createDocumentFragment();

    state.reviews.forEach((review, index) => {
      const images = Array.isArray(review.images) ? review.images : [];
      const rating = Math.max(1, Math.min(5, review.rating || 5));
      const card = document.createElement("button");
      card.className = "review-room__card";
      card.type = "button";
      card.dataset.reviewIndex = String(index);
      card.setAttribute("role", "listitem");
      card.setAttribute(
        "aria-label",
        `Open ${displayNickname(review.nickname)}'s review of ${review.productTitle || "a Yizcho resident"}`,
      );

      const leftHanger = document.createElement("img");
      leftHanger.className = "review-room__hanger review-room__hanger--card-left";
      leftHanger.src = assetUrls.rope;
      leftHanger.alt = "";
      leftHanger.setAttribute("aria-hidden", "true");
      const rightHanger = document.createElement("img");
      rightHanger.className = "review-room__hanger review-room__hanger--card-right";
      rightHanger.src = assetUrls.rope;
      rightHanger.alt = "";
      rightHanger.setAttribute("aria-hidden", "true");

      const photo = document.createElement("span");
      photo.className = "review-room__card-media";
      const photoImage = document.createElement("img");
      photoImage.alt = "";
      photoImage.loading = index < 4 ? "eager" : "lazy";
      photoImage.decoding = "async";
      photoImage.fetchPriority = index < 2 ? "high" : "low";
      photoImage.src = images[0];
      photo.append(photoImage);

      const body = document.createElement("span");
      body.className = "review-room__card-body";

      const meta = document.createElement("span");
      meta.className = "review-room__card-meta";
      const ratingStars = document.createElement("span");
      ratingStars.className = "review-room__card-stars";
      ratingStars.textContent = "★".repeat(rating);
      ratingStars.setAttribute("aria-label", `${rating} out of 5 stars`);
      const reviewer = document.createElement("strong");
      reviewer.className = "review-room__card-name";
      reviewer.textContent = displayNickname(review.nickname);
      meta.append(ratingStars, reviewer);

      const excerpt = document.createElement("span");
      excerpt.className = "review-room__card-copy";
      excerpt.textContent = review.review || "A collector welcomed this Yizcho resident home.";

      const source = document.createElement("span");
      source.className = "review-room__card-product";
      source.textContent = review.productTitle || "Yizcho resident";

      const action = document.createElement("span");
      action.className = "review-room__card-action";
      const envelope = document.createElement("img");
      envelope.src = assetUrls.envelope;
      envelope.alt = "";
      envelope.setAttribute("aria-hidden", "true");
      const actionLabel = document.createElement("span");
      actionLabel.textContent = "Open letter";
      const arrow = document.createElement("img");
      arrow.src = assetUrls.arrowRight;
      arrow.alt = "";
      arrow.setAttribute("aria-hidden", "true");
      action.append(envelope, actionLabel, arrow);

      body.append(meta, excerpt, source, action);
      card.append(leftHanger, rightHanger, photo, body);
      fragment.append(card);
    });

    list.replaceChildren(fragment);
  }

  function nextIdleTurn() {
    return new Promise((resolve) => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(resolve, { timeout: 450 });
        return;
      }
      window.setTimeout(resolve, 32);
    });
  }

  function warmReviewImages() {
    if (state.imageWarmup) return state.imageWarmup;
    const images = [
      ...list.querySelectorAll(".review-room__card-media img"),
    ];
    state.imageWarmup = (async () => {
      for (const [index, image] of images.entries()) {
        if (index >= 4) await nextIdleTurn();
        image.loading = "eager";
        try {
          await image.decode?.();
        } catch {
          // The card keeps its background color if a collector image fails.
        }
      }
    })().finally(() => {
      state.imageWarmup = null;
    });
    return state.imageWarmup;
  }

  function setCollapsed(collapsed) {
    state.collapsed = Boolean(collapsed);
    root.classList.toggle("is-collapsed", state.collapsed);
    trigger.setAttribute("aria-expanded", String(!state.collapsed));
    trigger.setAttribute(
      "aria-label",
      state.collapsed ? "Expand collector letters" : "Collapse collector letters",
    );
    listViewport.setAttribute("aria-hidden", String(state.collapsed));
    listViewport.inert = state.collapsed;
  }

  function preloadNextReview() {
    if (state.reviews.length < 2) return;
    const nextReview = state.reviews[(state.index + 1) % state.reviews.length];
    const source = nextReview?.images?.[0];
    if (!source) return;
    const preload = new Image();
    preload.src = source;
  }

  function render() {
    const review = selectedReview();
    if (!review) {
      reviewCopy.textContent = "No collector letters are available yet.";
      position.textContent = "0 / 0";
      image.hidden = true;
      imagePlaceholder.hidden = false;
      previousButton.disabled = true;
      nextButton.disabled = true;
      return;
    }

    const images = Array.isArray(review.images) ? review.images : [];
    state.photoIndex = Math.min(
      state.photoIndex,
      Math.max(0, images.length - 1),
    );
    const rating = Math.max(1, Math.min(5, review.rating || 5));
    stars.textContent = "★".repeat(rating);
    stars.setAttribute("aria-label", `${rating} out of 5 stars`);
    nickname.textContent = displayNickname(review.nickname);
    verified.hidden = !review.verifiedPurchase;
    incentivized.hidden = !review.incentivized;
    reviewCopy.textContent =
      review.review || "A collector welcomed this Yizcho resident home.";
    product.textContent = review.productTitle || "";
    date.textContent = formatDate(review.date);
    date.dateTime = review.date || "";
    position.textContent = `${state.index + 1} / ${state.reviews.length}`;
    previousButton.disabled = state.reviews.length < 2;
    nextButton.disabled = state.reviews.length < 2;

    if (images.length) {
      image.src = images[state.photoIndex];
      image.alt = `${review.productTitle}, collector photo ${
        state.photoIndex + 1
      } of ${images.length}`;
      image.hidden = false;
      imagePlaceholder.hidden = true;
      imageButton.disabled = images.length < 2;
      imageCount.textContent =
        images.length > 1
          ? `Photo ${state.photoIndex + 1} / ${images.length} · tap for next`
          : "Collector photo";
    } else {
      image.removeAttribute("src");
      image.alt = "";
      image.hidden = true;
      imagePlaceholder.hidden = false;
      imageButton.disabled = true;
      imageCount.textContent = "A note from its new home";
    }
    preloadNextReview();
  }

  function shiftReview(direction) {
    if (state.reviews.length < 2) return;
    state.index =
      (state.index + direction + state.reviews.length) % state.reviews.length;
    state.photoIndex = 0;
    dialog.classList.remove("is-changing");
    void dialog.offsetWidth;
    dialog.classList.add("is-changing");
    render();
  }

  function shiftPhoto() {
    const images = selectedReview()?.images || [];
    if (images.length < 2) return;
    state.photoIndex = (state.photoIndex + 1) % images.length;
    render();
  }

  async function loadReviews() {
    if (state.reviews.length) return state.reviews;
    if (state.loading) return state.loading;
    streamStatus.textContent = "Opening the island mailbag…";
    state.loading = fetch(root.dataset.reviewsUrl, {
      credentials: "same-origin",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Review data returned ${response.status}`);
        }
        return response.json();
      })
      .then((payload) => {
        state.reviews = (
          Array.isArray(payload.reviews) ? payload.reviews : []
        ).filter(
          (review) => Array.isArray(review.images) && review.images.length,
        );
        triggerCount.textContent = `${state.reviews.length} collector letters`;
        renderReviewList();
        warmReviewImages();
        writeReview.hidden = !writeReview.dataset.looxProductId;
        streamStatus.textContent = state.reviews.length
          ? `${state.reviews.length} collector letters are ready.`
          : "No collector letters are available yet.";
        return state.reviews;
      })
      .catch((error) => {
        console.error("Unable to load collector reviews", error);
        streamStatus.textContent =
          "The island mailbag could not be opened. Please try again.";
        writeReview.hidden = true;
        state.reviews = [];
        return state.reviews;
      })
      .finally(() => {
        state.loading = null;
      });
    return state.loading;
  }

  async function openDialog({ index = null, reset = false } = {}) {
    if (!state.inRoom) return;
    await loadReviews();
    if (!state.inRoom || !state.reviews.length) return;
    if (reset) {
      state.index = 0;
      state.photoIndex = 0;
    }
    if (Number.isInteger(index)) {
      state.index = Math.max(0, Math.min(index, state.reviews.length - 1));
      state.photoIndex = 0;
    }
    state.lastFocus =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : list.querySelector(`[data-review-index="${state.index}"]`) || trigger;
    state.open = true;
    render();
    backdrop.hidden = false;
    dialog.hidden = false;
    dialog.inert = false;
    dialog.setAttribute("aria-hidden", "false");
    document.body.classList.add("has-review-letter", "has-review-dialog");
    window.requestAnimationFrame(() => {
      backdrop.classList.add("is-open");
      dialog.classList.add("is-open");
      closeButton.focus({ preventScroll: true });
    });
  }

  function closeDialog({ immediate = false, restoreFocus = true } = {}) {
    if (!state.open && dialog.hidden) return;
    state.open = false;
    backdrop.classList.remove("is-open");
    dialog.classList.remove("is-open", "is-changing");
    dialog.setAttribute("aria-hidden", "true");
    dialog.inert = true;
    document.body.classList.remove("has-review-letter", "has-review-dialog");
    const finish = () => {
      if (state.open) return;
      backdrop.hidden = true;
      dialog.hidden = true;
      if (restoreFocus && state.inRoom) {
        const focusTarget = state.lastFocus?.isConnected ? state.lastFocus : trigger;
        focusTarget.focus({ preventScroll: true });
      }
    };
    if (immediate) finish();
    else window.setTimeout(finish, 260);
  }

  function waitForLooxReviewForm(timeout = 6000) {
    const getForm = () => {
      if (typeof window.LOOX?.showReviewForm !== "function") return null;
      return window.LOOX.showReviewForm.bind(window.LOOX);
    };
    const ready = getForm();
    if (ready) return Promise.resolve(ready);

    return new Promise((resolve, reject) => {
      const started = Date.now();
      const check = () => {
        const form = getForm();
        if (form) {
          resolve(form);
          return;
        }
        if (Date.now() - started >= timeout) {
          reject(new Error("Loox review form did not become ready"));
          return;
        }
        window.setTimeout(check, 100);
      };
      check();
    });
  }

  async function openWriteReview() {
    if (!state.inRoom || writeReview.disabled) return;
    const productId = writeReview.dataset.looxProductId;
    if (!productId) return;

    const label = writeReview.querySelector("span");
    const originalLabel = label?.textContent || "Write a review";
    writeReview.disabled = true;
    writeReview.setAttribute("aria-busy", "true");
    if (label) label.textContent = "Opening…";
    streamStatus.textContent = "Opening the review form…";

    try {
      const showReviewForm = await waitForLooxReviewForm();
      if (!state.inRoom) return;
      showReviewForm(productId);
      streamStatus.textContent = "The review form is open.";
    } catch (error) {
      console.error("Unable to open the Loox review form", error);
      streamStatus.textContent =
        "The review form is still loading. Please try again.";
    } finally {
      writeReview.disabled = false;
      writeReview.removeAttribute("aria-busy");
      if (label) label.textContent = originalLabel;
    }
  }

  function syncRoomState() {
    const selected = hasSelectedHouse();
    const roomEntry = document.querySelector("#room-entry");
    const inRoom =
      selected &&
      document.body.classList.contains("has-room") &&
      Boolean(roomEntry?.hidden);
    const selectedHouse = selected && !state.selected;
    const enteredRoom = inRoom && !state.inRoom;

    state.selected = selected;
    state.inRoom = inRoom;
    root.hidden = !inRoom;
    document.body.classList.toggle("has-review-house-selected", selected);
    document.body.classList.toggle("has-review-room", inRoom);

    if (selectedHouse) {
      prepareReviewChrome();
      loadReviews();
    }

    if (enteredRoom) {
      root.classList.remove("is-ready");
      setCollapsed(false);
      window.requestAnimationFrame(() => root.classList.add("is-ready"));
      loadReviews();
    } else if (!inRoom) {
      root.classList.remove("is-ready");
      closeDialog({ immediate: true, restoreFocus: false });
    }
  }

  trigger.addEventListener("click", () => setCollapsed(!state.collapsed));
  trigger.addEventListener("pointerenter", loadReviews, { once: true });
  list.addEventListener("click", (event) => {
    const card = event.target.closest("[data-review-index]");
    if (!card) return;
    openDialog({ index: Number(card.dataset.reviewIndex) });
  });
  backdrop.addEventListener("click", () => closeDialog());
  closeButton.addEventListener("click", () => closeDialog());
  previousButton.addEventListener("click", () => shiftReview(-1));
  nextButton.addEventListener("click", () => shiftReview(1));
  imageButton.addEventListener("click", shiftPhoto);
  writeReview.addEventListener("click", openWriteReview);

  dialog.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "mouse") return;
    state.pointerStartX = event.clientX;
  });
  dialog.addEventListener("pointerup", (event) => {
    if (state.pointerStartX === null) return;
    const distance = event.clientX - state.pointerStartX;
    state.pointerStartX = null;
    if (Math.abs(distance) < 54) return;
    shiftReview(distance > 0 ? -1 : 1);
  });
  dialog.addEventListener("pointercancel", () => {
    state.pointerStartX = null;
  });

  document.addEventListener(
    "keydown",
    (event) => {
      const activeDialog = state.open ? dialog : null;
      if (event.key === "Tab" && activeDialog) {
        const focusable = [
          ...activeDialog.querySelectorAll(
            "a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])",
          ),
        ].filter((element) => element.getClientRects().length > 0);
        if (focusable.length) {
          const currentIndex = focusable.indexOf(document.activeElement);
          const nextIndex = event.shiftKey
            ? currentIndex <= 0
              ? focusable.length - 1
              : currentIndex - 1
            : currentIndex < 0 || currentIndex === focusable.length - 1
              ? 0
              : currentIndex + 1;
          event.preventDefault();
          event.stopImmediatePropagation();
          focusable[nextIndex].focus({ preventScroll: true });
        }
        return;
      }
      if (event.key === "Escape") {
        if (state.open) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeDialog();
        }
        return;
      }
      if (!state.open) return;
      if (event.key === "ArrowLeft") shiftReview(-1);
      if (event.key === "ArrowRight") shiftReview(1);
    },
    true,
  );

  const observer = new MutationObserver(syncRoomState);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
  });
  syncRoomState();
}
